import { useMutation, useQuery } from '@tanstack/react-query';
import { checkout, fetchSubscription } from '.';

export const useGetSubscription = () => {
  return useQuery({
    queryKey: ['subscription'],
    queryFn: fetchSubscription,
    staleTime: 60 * 1000,
  });
};

export const useCheckout = () => {
  return useMutation({
    mutationFn: checkout,
  });
};
